module.exports = __webpack_public_path__ + "static/media/app4.c74786b0.jpg";